/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { PerpFiOwnableUpgradeFake } from "./PerpFiOwnableUpgradeFake";

export class PerpFiOwnableUpgradeFakeFactory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<PerpFiOwnableUpgradeFake> {
    return super.deploy(overrides || {}) as Promise<PerpFiOwnableUpgradeFake>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): PerpFiOwnableUpgradeFake {
    return super.attach(address) as PerpFiOwnableUpgradeFake;
  }
  connect(signer: Signer): PerpFiOwnableUpgradeFakeFactory {
    return super.connect(signer) as PerpFiOwnableUpgradeFakeFactory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): PerpFiOwnableUpgradeFake {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as PerpFiOwnableUpgradeFake;
  }
}

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "candidate",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "setOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "updateOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
